import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { Redirect, NavLink } from "react-router-dom";
import { withFormik } from "formik";
import Paper from "@material-ui/core/Paper";
import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import Input from "@material-ui/core/Input";
import _ from 'lodash';
import InputAdornment from "@material-ui/core/InputAdornment";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import Button from "@material-ui/core/Button";
import { SnackbarContent, Typography } from "@material-ui/core";
import { loginRequest } from "store/state/auth";
import { initiateRedirect } from "store/state/loading";
import { validationSchema } from "shapes/login";
import { withStyles } from "@material-ui/core/styles";
import {ROUTE_DASHBOARD, ROUTE_BROKER_DASHBOARD, ROUTE_GUEST_LANDING, POLICIES_AND_AGREEMENTS} from 'constants/routes';
import { withLDConsumer } from "launchdarkly-react-client-sdk";
import featureFlags from "constants/featureFlags";
import RedirectToAuthUI from "./RedirectToAuthUI";
import { buildLoginPath } from "helpers/auth-redirect";

const styles = {
  root: {
    background: "transparent"
  },
  input: {
    color: "#333",
    fontWeight: "100",
    backgroundColor: "#fff",
    fontFamily: "Roboto"
  },
  divider: {
    backgroundColor: "#fff",
    marginBottom: "10px",
    marginTop: "10px"
  },
  white: {
    color: "#fff",
    fontFamily: "Futura",
    fontWeight: "bold",
    letterSpacing: "1px",
    lineHeight: "1em"
  },
  blue: {
    color: "#0f90d0",
    fontFamily: "Futura",
    fontWeight: "bold",
    letterSpacing: "1px",
    lineHeight: "1em"
  },
  caption: {
    color: "#fff",
    fontWeight: "100",
    letterSpacing: "1px",
    fontFamily: "Roboto"
  },
  boldText: {
    fontWeight: "900"
  },
  button: {
    backgroundColor: "rgba(15, 144, 208, 1)",
    color: "#fff",
    width: "100px",
    borderRadius: "20px",
    fontFamily: "Roboto",
    "&:hover": {
      backgroundColor: "rgba(15, 144, 208, .7)"
    }
  },
  label: {
    fontFamily: "Roboto",
    color: "#fff",
    fontWeight: "100",
    letterSpacing: "1px",
    
    marginBottom: "5px"
  }
};

export class Login extends Component {
  state = {
    animate: false,
    passwordVisible: false,
    touched: false
  };
  componentDidMount() {
    setTimeout(() => {
      this.setState({ animate: true });
    }, 500);
  }

  togglePasswordMask = () =>
    this.setState(prevState => ({
      passwordVisible: !prevState.passwordVisible
    }));
    
  renderErrorView = (authentication) => {
    return (
      <Grid item xs={12}>
        <div>
          {authentication.error === "unauthorized" ||
            (authentication.error ===
              "Request failed with status code 403" && (
              <SnackbarContent
                className="snackbarContentWarning"
                message="Invalid Email or Password"
              />
            ))}
          {authentication.error === "API endpoint missing" && (
            <SnackbarContent
              className="snackbarContentWarning"
              message="API missing or API server down"
            />
          )}
          {authentication.error === "API didn't respond" && (
            <SnackbarContent
              className="snackbarContentWarning"
              message="API not responded"
            />
          )}
        </div>
      </Grid>
    );
  };
  
  renderEmailField = (classes, values, errors, touched, handleChange) => {
    return (
      <Grid item xs={12}>
        <Typography
          variant="display3"
          className={`${classes.white} robotText`}
        >
          DEBT.
        </Typography>
        <Typography
          variant="display3"
          className={`${classes.blue} robotText`}
        >
          SMARTER.
        </Typography>
        <Divider className={classes.divider} />
        <Typography
          className={`${classes.caption} ${classes.boldText}`}
          variant="body2"
          gutterBottom
        >
          Sign in to LoanBoss.
        </Typography>
        <FormControl
          fullWidth
          error={errors.email && touched.email}
        >
          <Typography variant="body1" className={classes.label}>
            Email
          </Typography>
          <Input
            tabIndex="1"
            variant="filled"
            id="email"
            className={classes.input}
            type="text"
            value={values.email}
            autoComplete="off"
            onChange={handleChange}
            placeholder=" JohnDoe@email.com"
          />
          {errors.email &&
            touched.email && (
              <FormHelperText id="name-error-text">
                {errors.email}
              </FormHelperText>
            )}
        </FormControl>
      </Grid>
    );
  };
  
  renderPasswordField = (classes, values, errors, touched, handleChange) => {
    return (
      <Grid item xs={12}>
        <FormControl
          fullWidth
          error={errors.password && touched.password}
        >
          <Grid container spacing={24}>
            <Grid item xs={6}>
              <Typography variant="body1" className={classes.label}>
                Password
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography align="right">
                <NavLink to="/forgotPassword" tabIndex="3">
                  Forgot password?
                </NavLink>
              </Typography>
            </Grid>
          </Grid>
          <Input
            tabIndex = "2"
            id="password"
            className={classes.input}
            type={this.state.passwordVisible ? "text" : "password"}
            value={values.password}
            onChange={handleChange}
            placeholder=" Enter your password"
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  id="togglePasswordMask"
                  onClick={this.togglePasswordMask}
                  onMouseDown={this.handle_MouseDownPassword}
                >
                  {this.state.passwordVisible ? (
                    <Visibility />
                  ) : (
                    <VisibilityOff />
                  )}
                </IconButton>
              </InputAdornment>
            }
          />
          {errors.password &&
            touched.password && (
              <FormHelperText id="name-error-text">
                {errors.password}
              </FormHelperText>
            )}
        </FormControl>
      </Grid>
    );
  };

  hasGuestOnlyAccess = () => this.props.authentication && this.props.authentication.guestAccess==="guest";
  
  userPrefersBrokerDashboardView = () => this.props.authentication?.user?.prefersBrokerDashboardView;

  renderUnauthRedirect = () => {
    const from = this.props.location?.state?.from;
    const backTo = from ? from.pathname + (from.search || "") : null;
    return <RedirectToAuthUI to={buildLoginPath(backTo ?? "")} />;
  };

  renderPostAuthRedirect = (authentication) => {
    let path;
    if (authentication && authentication.user && !authentication.user.hasAcceptedAgreement) {
      path = POLICIES_AND_AGREEMENTS;
    } else {
      const authRedirectProps = JSON.parse(localStorage.getItem("authRedirect"));
      let dashboardRoute = ROUTE_DASHBOARD;
      if (this.userPrefersBrokerDashboardView()) {
        dashboardRoute = ROUTE_BROKER_DASHBOARD;
      }
      path = this.hasGuestOnlyAccess() ? ROUTE_GUEST_LANDING : dashboardRoute;
      const potentialPath = _.get(authRedirectProps, "computedMatch.url");
      if (potentialPath) {
        this.props.history.push(potentialPath);
        localStorage.removeItem("authRedirect");
      }
    }

    if (this.userPrefersBrokerDashboardView()
        && this.props.flags[featureFlags.US1999_BROKER_FRONTEND_REDIRECT]) {
      this.props.initiateRedirect();
      window.location.href = this.props.flags[featureFlags.US1304_BROKER_FRONTEND_URL];
      return null;
    }

    return <Redirect to={path} />;
  };

  render() {
    const {
      classes,
      loading,
      authentication,
      handleChange,
      handleSubmit,
      values,
      errors,
      touched
    } = this.props;
    const { authed, authError } = authentication;

    if (!loading.authentication && !authed) {
      return this.renderUnauthRedirect();
    }

    if (!loading.authentication && authed) {
      return this.renderPostAuthRedirect(authentication);
    }

    return (
      <Fragment>
        <Grid className="login_Panel" container spacing={24}>
          <Grid item xs={12} className="login_PanelInner">
            <Paper
              className={`login_PanelInnerPaper shouldAnimate ${
                this.state.animate ? "animateDownFadeIn" : ""
              }`}
            >
              <form
                onSubmit={handleSubmit}
                id="login_no_human"
                autoComplete="new-password"
              >
                <Grid container spacing={24}>
                  { this.renderEmailField(classes, values, errors, touched, handleChange) }

                  { this.renderPasswordField(classes, values, errors, touched, handleChange) }

                  <Grid item xs={12}>
                    <FormControl fullWidth>
                      <Button
                        type="submit"
                        size="large"
                        className={classes.button}
                        id="submitButton"
                      >
                        Login
                      </Button>
                    </FormControl>
                  </Grid>

                  { authError && this.renderErrorView(authentication, authError) }
                </Grid>
              </form>
            </Paper>
          </Grid>
        </Grid>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ authentication, loading }) => ({
  authentication,
  loading
});

export default compose(
  withLDConsumer(),
  connect(
    mapStateToProps,
    { loginRequest, initiateRedirect }
  ),
  withFormik({
    mapPropsToValues: () => ({ email: "", password: "" }),
    validationSchema,
    handleSubmit: (values, { props }) => {
      props.loginRequest({ ...values, pathname: props.location.pathname });
    },
    displayName: "LoginForm"
  }),
  withStyles(styles)
)(Login);
